import { Image, Spacer, Text } from '@vinted/web-ui'

type Props = { imageSource: string; blockHeading: string; blockText: string }

const AboutFactBlock = ({ imageSource, blockHeading, blockText }: Props) => {
  return (
    <div className="about__fact-block">
      <div className="about__fact-icon">
        <div className="c-image--large">
          <Image role="img" src={imageSource} scaling="cover" />
        </div>
      </div>
      <div className="about__content">
        <Text as="h5" alignment="left">
          <span
            className="c-text--responsive-small-heading"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: blockHeading }}
          />
        </Text>
        <Spacer size="large" />
        <Text as="p" alignment="left">
          <span
            className="c-text--responsive-small-body"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: blockText }}
          />
        </Text>
      </div>
    </div>
  )
}

export default AboutFactBlock
